import { useCallback } from "react";
import { cn } from "@/lib/utils";

interface ObfuscatedEmailProps {
  user?: string;
  domain?: string;
  className?: string;
  children?: React.ReactNode;
}

/**
 * Spam-protected email link.
 * The mailto: href is only built on click (not in the DOM),
 * and the visible text uses a data-attribute approach so
 * crawlers can't easily scrape the address.
 */
export function ObfuscatedEmail({
  user = "info",
  domain = "emoose.de",
  className,
  children,
}: ObfuscatedEmailProps) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      window.location.href = `mailto:${user}@${domain}`;
    },
    [user, domain]
  );

  return (
    <a
      href="#kontakt"
      onClick={handleClick}
      className={cn("cursor-pointer", className)}
      aria-label={`E-Mail senden an ${user} at ${domain}`}
    >
      {children ?? (
        <span>
          {user}
          <span className="hidden" aria-hidden="true">REMOVE</span>
          @
          <span className="hidden" aria-hidden="true">REMOVE</span>
          {domain}
        </span>
      )}
    </a>
  );
}
